<template>
    <editing-sub-frame :sub_type="sub_type" :sub_code="sub_code">
        <!--제목, 컴포넌트 기본 공통 -->
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->
            
            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력" />    
            </template>
            
            <div class="mt-3 mb-1 fw-600 f-90"> Sub type </div>
            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="(sub_type, sub_type_idx) in sub_types"
                        :key="`subs-guidetext-subtype-opt-${sub_type}-${sub_type_idx}`"
                        @click="selectType(sub_type)"
                        >
                        {{ sub_type }}
                    </b-dropdown-item-button>
                </b-dropdown>

                <b-input v-model="sub_name" placeholder="Title (필요시 작성)"> {{ sub_name }} </b-input>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90">Description</div>
            <b-textarea v-model="sub_description" placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?"> {{ sub_description }} </b-textarea>

            <div class="mt-3 mb-1 fw-600 f-90">Info</div>
            <b-textarea v-model="sub_info" placeholder="용어설명, 참고사항, 평가기준 등 답변 참고정보" > {{ sub_info }} </b-textarea>
        </template>
        
        <template #structure>
            <!-- DF GuideText -->
            <div class="mt-3 mb-1 f-90 d-flex justify-content-between">
                <div class="fw-600 "> Structure</div>
                <div class="d-flex justify-content-end">
                    <b-form-checkbox v-model="sub_data_header.html" class="mr-3 blue">Html</b-form-checkbox>         
                    <b-form-checkbox v-model="sub_data_header.bordered" class="blue">테두리 박스 있음</b-form-checkbox> 
                </div>                      
            </div>         
            <b-textarea v-model="sub_data_contents.structure[0]" placeholder="가이드텍스트를 입력해주세요" rows="5"></b-textarea>
        </template>

        <template #option>
            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부문항"
                        :label-for="`editing-subs-guidetext-${sub_code}-has_attachment`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-guidetext-${sub_code}-has_attachment`"
                            v-model="has_attachment"
                            >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부필수"
                        :label-for="`editing-subs-guidetext-${sub_code}-required_attachment`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-guidetext-${sub_code}-required_attachment`"
                            v-model="required_attachment"
                            :disabled="!has_attachment"
                            >
                            첨부필수 문항
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Risk"
                        :label-for="`editing-subs-guidetext-${sub_code}-risk`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-guidetext-${sub_code}-risk`"
                            v-model="sub_risk"
                            >
                            적용
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Child"
                        :label-for="`editing-subs-guidetext-${sub_code}-child`"
                        class="align-items-center mb-0"
                        >

                        <b-form-checkbox :id="`editing-subs-guidetext-${sub_code}-child`"
                            v-model="has_child"
                            @change="handleHasChild"
                            >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        :label-for="`editing-subs-guidetext-${sub_code}-condition`"
                        class="align-items-center mb-0"
                        >

                        <template #label>
                            Condition
                            <fa :id="`sub_condition_information_${sub_code}`" icon="info-circle"></fa>

                            <b-popover :target="`sub_condition_information_${sub_code}`" title="설명"
                                placement="left"
                                triggers="hover"
                                :content="sub_condition_information"
                                >
                            </b-popover>
                        </template>

                        <b-form-checkbox :id="`editing-subs-guidetext-${sub_code}-condition`"
                            v-model="is_condition_available"
                            @input="manageConditionAvailability"
                            >
                            <b-form-input placeholder="선행조건 표시내용을 입력해 주세요" v-model="sub_condition.text"> {{ sub_condition.text }} </b-form-input>
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Scoring"
                        :label-for="`editing-subs-guidetext-${sub_code}-scoring`"
                        class="align-items-center mb-0"
                        >
                        <b-dropdown :text="scoring" :id="`editing-subs-guidetext-${sub_code}-scoring`" size="sm" variant="dark-border">
                            <b-dropdown-item @click="setScoring('none')" >No Scoring</b-dropdown-item>
                            <b-dropdown-item @click="setScoring('auto')">Auto Scoring</b-dropdown-item>
                        </b-dropdown>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="필수 응답(Public ONLY)"
                        :label-for="`editing-subs-guidetext-${sub_code}-required_answer`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-guidetext-${sub_code}-required_answer`"
                            v-model="required_answer"
                            >
                            필수 응답(Public ONLY)
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>


                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-guidetext-${sub_code}-tags`"
                        class="align-items-center mb-0"
                        >
                        <b-input :id="`editing-subs-guidetext-${sub_code}-tags`" v-model="tags"
                            placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                            />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </template>

        <template #footer>
            <div class="text-right">
                <b-button variant="blue" class="mr-2"
                    @click="handleSaveSub"
                    :disabled="is_saving_subs"
                    >
                    <div class="d-flex align-items-center">
                        저장 <b-spinner v-show="is_saving_subs" small class="ml-2" />
                    </div>
                </b-button>
                <b-button @click="$emit('click-cancel')" variant="dark">취소</b-button>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import { EditingSubComponentMixin } from '@core_mixins/EditingSubComponentMixin'

export default {
    name: 'editing-df-guidetext',
    mixins: [EditingSubComponentMixin],
    methods: {
        async handleSaveSub () {
            await this.saveSub()
            this.$emit('click-save')
        }
    },
}
</script>
